import { ErrorMessageSchema } from "@common/schemas/error.schema";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const gustoContract = c.router(
    {
        syncConnection: {
            method: "POST",
            path: "/sync/:connectionId",
            pathParams: z.object({
                connectionId: z.coerce.number(),
            }),
            body: c.noBody(),
            responses: {
                200: z.any(),
            },
        },
        createGustoAccount: {
            method: "POST",
            path: "/create-account/:workspaceId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            body: z.any(),
            responses: {
                200: z.object({
                    accountClaimUrl: z.string(),
                }),
                422: ErrorMessageSchema,
            },
        },
        reconcileTransfers: {
            method: "POST",
            path: "/reconcile-transfers",
            body: z.object({
                gustoAccountId: z.number(),
                transactionIds: z.array(z.number()),
            }),
            responses: {
                200: z.object({
                    matched: z.number(),
                    results: z.array(
                        z.object({
                            originalId: z.number(),
                            createdId: z.number(),
                        }),
                    ),
                }),
            },
        },
    },
    { pathPrefix: "/gusto-connection" },
);
